import { render, staticRenderFns } from "./process_management.vue?vue&type=template&id=44dcac8b&scoped=true&"
import script from "./process_management.vue?vue&type=script&lang=js&"
export * from "./process_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dcac8b",
  null
  
)

export default component.exports